if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.isFeaturedProduct = this.closest('.section-featured-product') !== null; // Add this line
      
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      
      // Modified section: Differentiate between featured product and subscriptions
      if (this.isFeaturedProduct) {
        // Handle featured product with checkboxes
        this.closest('.section-featured-product').querySelectorAll('.variant-checkbox:checked').forEach((checkbox, index) => {
          const quantityInput = checkbox.closest('.variant-option-item').querySelector('.quantity-input');
          formData.append(`items[${index}][id]`, checkbox.value);
          formData.append(`items[${index}][quantity]`, quantityInput.value || 1);
        });
      } else {
        // Handle subscription plans
        const variantId = this.form.querySelector('[name="id"]').value;
        const sellingPlan = this.form.querySelector('.selling-plan-input')?.value;
        formData.append('items[0][id]', variantId);
        formData.append('items[0][quantity]', 1);
        if (sellingPlan) formData.append('items[0][selling_plan]', sellingPlan);
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: response,
          });

          if (this.cart) {
            this.cart.renderContents(response);
            this.cart.open();
          }
        })
        .catch(error => {
          console.error(error);
          this.handleErrorMessage('An error occurred. Please try again.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }

    // Keep the rest of your original methods
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}